import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

const MainLayout = ({ children }) => {
    return (
        <div className="min-h-screen bg-[#1E1E1E]">
            <Header />
            <div className="flex" style={{ height: 'calc(100vh - 3.5rem)' }}>
                <Sidebar />
                <main className="flex-1">
                    <div className="max-w-[90rem] mx-auto py-6 sm:px-6 lg:px-8">
                        <div className="px-4 py-6 sm:px-0">
                            {children}
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default MainLayout; 